'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _reselect = require('reselect');

var _BoardSharingUtil = require('../header/utils/sharing/BoardSharingUtil');

var _BoardSharingUtil2 = _interopRequireDefault(_BoardSharingUtil);

var _ElementFilterUtil = require('../header/utils/elementFilter/ElementFilterUtil');

var _ElementFilterUtil2 = _interopRequireDefault(_ElementFilterUtil);

var _sharingUtilSelector = require('../header/utils/sharing/sharingUtilSelector');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var statsSelector = (0, _reselect.createSelector)(_sharingUtilSelector.usersCurrentlyViewingSelector, function (usersCurrentlyViewing) {
    return {
        activeUsers: usersCurrentlyViewing ? usersCurrentlyViewing.size : 0
    };
});

// Components


var StatsComponent = function StatsComponent(_ref) {
    var currentBoardId = _ref.currentBoardId,
        elementFilter = _ref.elementFilter,
        activeUsers = _ref.activeUsers;

    if (elementFilter) return _react2.default.createElement(_ElementFilterUtil2.default, { currentBoardId: currentBoardId, elementFilter: elementFilter });
    return _react2.default.createElement(_BoardSharingUtil2.default, { currentBoardId: currentBoardId, isMobileView: true });
};

var MobilePageStats = function MobilePageStats(props) {
    return _react2.default.createElement(StatsComponent, props);
};

MobilePageStats.propTypes = StatsComponent.propTypes = {
    currentBoardId: _propTypes2.default.string.isRequired,
    elementFilter: _propTypes2.default.object,
    activeUsers: _propTypes2.default.number
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(statsSelector), _recompose.pure);

exports.default = enhance(MobilePageStats);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/mobile/MobilePageStats.js
// module id = 2203
// module chunks = 0